import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { hitYandexMetrika } from '@minibook/shared';

export function YandexMetrikaSpaHits() {
  const location = useLocation();
  const firstRef = useRef(true);

  useEffect(() => {
    if (firstRef.current) {
      firstRef.current = false;
      return;
    }
    const path = `${location.pathname}${location.search}${location.hash}`;
    hitYandexMetrika(path, { title: typeof document !== 'undefined' ? document.title : undefined });
  }, [location.pathname, location.search, location.hash]);

  return null;
}
